// Local storage keys
export const FILTERS_STORAGE_KEY = "panda_datatable_filters";
export const SHOW_FILTERS_STORAGE_KEY = "panda_datatable_show_filters";

// Filter version - increment this when adding/removing/changing filter structure
export const FILTERS_VERSION = 7;

// Default filter states
export const DEFAULT_FILTERS = {
  includeImages: true,
  imageColumnsExpanded: false, // When false, image columns are collapsed into a preview column
  showMetadataView: false, // When true, show row metadata (debug info) instead of data columns
  showDebugColumns: false, // reveal hidden debug columns (raw JSON-LD, *__json, address.* sub-fields) from structured-data extraction
};

// Product mode — the mobile-only grid view of a table (image + a few details per
// row). Its settings are stored per table, so the view a phone left a table in is
// the view it gets back.
export const PRODUCT_MODE_STORAGE_PREFIX = "panda_datatable_product_mode:";
export const PRODUCT_MODE_VERSION = 2;

// Below Tailwind's `md` breakpoint (768px), the same cut-off the header uses for
// its mobile layout.
export const MOBILE_MEDIA_QUERY = "(max-width: 767px)";

// "sheet" reflows the table into rows (number, image, title, price) under a
// sticky column header; "grid" is a wall of image tiles.
export const PRODUCT_MODE_LAYOUTS = ["sheet", "grid"];
export const PRODUCT_GRID_COLUMN_OPTIONS = [3, 4, 5];
// Rows and tiles fade in one after another when the view opens; everything
// past the last step shares its delay so a long page doesn't trickle in.
export const PRODUCT_MODE_REVEAL_STAGGER_MS = 35;
export const PRODUCT_MODE_REVEAL_MAX_STEPS = 24;
export const PRODUCT_MODE_MAX_FIELDS = 3;
// How many "1st / 2nd / 3rd…" image positions the settings sheet offers at most.
export const PRODUCT_MODE_MAX_IMAGE_POSITIONS = 6;

// Full-screen animations made for recordings: the intro ("Extracting data…"
// with the products landing one by one) when product mode opens, and the
// export animation (the products flying into a file) when an export starts.
// They are presentation choices rather than table ones, so each is
// remembered once per device.
export const PRODUCT_INTRO_STORAGE_KEY = "panda_datatable_product_intro";
export const PRODUCT_EXPORT_STORAGE_KEY = "panda_datatable_product_export";
export const PRODUCT_ANIMATION_VERSION = 1;
export const PRODUCT_ANIMATION_MIN_SECONDS = 2;
export const PRODUCT_ANIMATION_MAX_SECONDS = 20;
export const PRODUCT_ANIMATION_MAX_TILES = 48;
export const DEFAULT_PRODUCT_INTRO_SETTINGS = {
  enabled: false,
  durationSec: 5,
};
export const DEFAULT_PRODUCT_EXPORT_SETTINGS = {
  enabled: false,
  durationSec: 5,
};

export const DEFAULT_PRODUCT_MODE_SETTINGS = {
  enabled: false,
  layout: "sheet",
  imageColumnId: null, // null = every image column, in table order
  imageIndex: 0, // which of the row's images is shown (0-based)
  imageFit: "cover", // "cover" fills the image box, "contain" shows the whole image
  gridColumns: 4,
  fieldIds: null, // null = auto: title, URL and price for the sheet; price for the grid
  hideWithoutImages: false,
  covers: {}, // rowId -> image URL picked from the gallery for that row
};
